import { Toaster } from 'react-hot-toast';
import { useThemeStore } from '../../store/theme-store';

export const Toast = () => {
  const theme = useThemeStore((state) => state.theme);

  return (
    <Toaster
      position="top-right"
      toastOptions={{
        className: '!bg-background !border !text-foreground',
        style: {
          background: theme === 'dark' ? 'hsl(var(--background))' : 'white',
          color: theme === 'dark' ? 'white' : 'black',
          border: '1px solid hsl(var(--border))',
        },
        success: {
          iconTheme: {
            primary: 'hsl(var(--primary))',
            secondary: 'hsl(var(--primary-foreground))',
          },
        },
        error: {
          iconTheme: {
            primary: 'hsl(var(--destructive))',
            secondary: 'hsl(var(--destructive-foreground))',
          },
        },
        duration: 3000,
      }}
    />
  );
};